import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventItem, League, Lookups} from "@model";
import dayjs from 'dayjs'

@Component({
  selector: 'events-list-modal',
  templateUrl: './events-list-modal.component.html',
  styleUrls: ['./events-list-modal.component.scss']
})
export class EventsListModalComponent implements OnInit {
  @Input() league: League | undefined;
  @Input({required: true}) title: string | undefined;
  @Input({required: true}) tableColumnName: string | undefined;
  @Input() events: EventItem[] | undefined;
  @Input() raceCheckboxEnabled: boolean = true;
  @Input({required: true}) languages: Lookups[] = [];
  filteredEvents: EventItem[] | undefined = [];
  filteredInput: string = "";

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    if (this.events && this.events.length > 0) {
      this.filteredEvents = this.filterEvents(this.filteredInput, [...this.events]);
    }
  }

  onSave() {
    let events: EventItem[] = this.filteredEvents?.filter((eventItem: EventItem) => eventItem.discountApplied === true)!;
    this.activeModal.close(events);
  }

  onDismissClick(): void {
    /// https://github.com/ng-bootstrap/ng-bootstrap/issues/3721
    this.activeModal.dismiss();
  }

  onEventChange(event: EventItem) {
    if (event.racesList && event.racesList.length > 0) {
      for (var race of event.racesList) {
        race.discountApplied = event.discountApplied;
      }
    }
  }

  onRaceChange(event: EventItem) {
    var atLeastOneRaceIsSelected: boolean = false;
    for (var raceItem of event.racesList!) {
      if (raceItem.discountApplied) {
        atLeastOneRaceIsSelected = true;
      }
    }
    event.discountApplied = atLeastOneRaceIsSelected;
  }

  handleSearchInput(value: string): void {
    this.filteredInput = value;
    if (this.events && this.events.length > 0) {
      this.filteredEvents = this.filterEvents(this.filteredInput, [...this.events]);
    }
  }

  filterEvents(filteredInput: string | undefined, events: EventItem[] | undefined): EventItem[] {
    var filteredEvents: EventItem[];
    if (filteredInput === undefined) {
      filteredEvents = events ?? [];
    } else {
      filteredEvents = events!.filter((eventItem: EventItem) => {
        if (eventItem) {
          if (eventItem.name && eventItem.name.includes(filteredInput)) {
            return true;
          } else if (eventItem.nameEng && eventItem.nameEng.includes(filteredInput)) {
            return true;
          } else if (eventItem.nameIta && eventItem.nameIta.includes(filteredInput)) {
            return true;
          } else return !!(eventItem.nameSlo && eventItem.nameSlo.includes(filteredInput));
        } else {
          return false;
        }
      });
    }
    return filteredEvents;
  }

  isEventEndDateAfterLeagueEndDate(eventItem:EventItem, league:League) : boolean {
    var isEventEndDateAfterLeagueEndDate:boolean = false;
    if (eventItem.end && league.end) {
      isEventEndDateAfterLeagueEndDate = dayjs(eventItem.end).isAfter(league.end);
    }
    return isEventEndDateAfterLeagueEndDate;
  }
}

